'use strict';

const _ = require('underscore');
const Mn = require('backbone.marionette');
const Tooltip = require('common/ui/view/behavior/tooltip');
const Template = require('common/ui/template/sidebar/nav.hbs');

const SidebarNavView = Mn.View.extend({
    tagName: 'li',
    className: 'sidebar-nav-item',
    template: Template,
    events: {
        'click': 'toggle'
    },
    modelEvents: {
        'active': 'activate',
        'inactive': 'deactivate'
    },
    behaviors: [Tooltip],

    initialize: function() {
        this.listenBadgeChange();
    },

    onRender: function() {
        this.model.isActive() ? this.activate() : this.deactivate();
    },

    templateContext: function() {
        return {
            horizontal: this.getOption('horizontal'),
            badgeContent: this.getBadgeContent(),
            unread: this.hasUnread(),
        }
    },

    activate: function() {
        this.$el.addClass('is-active');
    },

    deactivate: function() {
        this.$el.removeClass('is-active');
    },

    toggle: function() {
        this.model.toggle();
    },

    getBadge: function() {
        return this.model.get('badge');
    },

    onChangeBadge: function() {
        this.render();
    },

    getBadgeContent: function() {
        if(!this.getBadge()) {
            return null;
        }

        return this.getBadge().content();
    },

    hasUnread: function() {
        if (!this.getBadge() || !this.getBadge().hasUnread) {
            return false;
        }

        return this.getBadge().hasUnread();
    },

    listenBadgeChange: function() {
        if(!this.getBadge() || !this.getBadge().listen) {
            return null;
        }

        return this.getBadge().listen(_.bind(this.onChangeBadge, this));
    }
});

module.exports = Mn.CollectionView.extend({
    childView: SidebarNavView,
    childViewOptions: function() {
        return {
            horizontal: this.getOption('horizontal')
        }
    }
});



// WEBPACK FOOTER //
// ./common/ui/view/sidebar/nav.js